import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { formatNumber } from '@/shared/lib/number';
import { calculatePrice } from '@/shared/lib/price';
import { useConfiguratorData } from '@/widgets/configurator';
import { useTranslation } from 'react-i18next';
import styles from './price.module.css';

export const Price = () => {
	const { t } = useTranslation();
	const { state } = useConfigurator();
	const {
		data: { prices },
	} = useConfiguratorData();

	const price = calculatePrice({ state, prices });
	const label = `${t('price.total')}: ${formatNumber(price)} UAH`;

	return (
		<div className={styles.wrapper}>
			<p className={styles.price}>{label}</p>
		</div>
	);
};
